import { isUndefinedOrNull } from '../../TypeHelpers';
import item from './item';
import where from './where';
export default function first(array, predicate) {
    if (!isUndefinedOrNull(predicate)) {
        array = [...where(array, predicate)];
    }
    const value = item(array, 0);
    if (isUndefinedOrNull(value)) {
        throw new Error("The collection is empty!");
    }
    return value;
}
